import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Popover } from 'react-tiny-popover';

import IconEllipsis from '@src/components/Icon/set/IconEllipsis';
import NLink from '@src/components/NLink';
import css from './style.module.scss';

const EllipsisBtn = (props) => {
	const { start, end, linkProps, getOnLinkClick, buildPagingHref } = props;

	const [isOpen, setIsOpen] = React.useState(false);

	const nums = Array.from({ length: end - start + 1 }, (_, k) => k + start);

	const btnNode = (
		<span
			className={css.ellipsis}
			onClick={() => setIsOpen(!isOpen)}
			tabIndex={0}
			role="button"
		>
			<IconEllipsis className={css.ellipsisIcon} />
		</span>
	);

	if (nums.length === 0) {
		return btnNode;
	}

	return (
		<Popover
			isOpen={isOpen}
			positions={['bottom', 'left']}
			align="start"
			padding={10}
			onClickOutside={() => setIsOpen(false)}
			content={
				<div className={cn(css.lines)}>
					{nums.map((switchNum) => {
						return (
							<NLink
								key={switchNum}
								href={buildPagingHref(switchNum)}
								onClick={getOnLinkClick(switchNum)}
								{...linkProps}
							>
								<a className={css.line}>
									<span>{switchNum}</span>
								</a>
							</NLink>
						);
					})}
				</div>
			}
		>
			{btnNode}
		</Popover>
	);
};

EllipsisBtn.propTypes = {
	start: PropTypes.number,
	end: PropTypes.number,
	isWithPopover: PropTypes.bool,
	linkProps: PropTypes.shape(NLink.propTypes),
	getOnLinkClick: PropTypes.func.isRequired,
	buildPagingHref: PropTypes.func.isRequired,
};

EllipsisBtn.defaultProps = {
	start: undefined,
	end: undefined,
	isWithPopover: undefined,
	linkProps: undefined,
};

export default EllipsisBtn;
